



















import { toCzj } from '@/app/core/utils'
import { Component, Mixins } from 'vue-property-decorator'
import { shuffle } from 'lodash'
import RecommendItem from './mixins/RecommendItem'

const Avatars: any[] = []
for (let i = 1; i <= 20; i++) {
  try {
    Avatars.push(require(`@assets/images/home/avatar_random/avatar_r_${i}.png`))
  } catch (e) {}
}
// console.log('Avatars require finished', Avatars)
if (Avatars.length == 0) {
  Avatars.push(require(`@assets/images/home/avatar_comment_default.png`))
}

@Component
export default class TopicItem extends Mixins(RecommendItem) {
  randomAvatars: any[] = []

  created() {
    this.randomAvatars = shuffle(Avatars)
  }

  /* 返回[min, max]随机整数（包含边界） */
  getRandomInt(min: number, max: number) {
    return Math.round(min + Math.random() * (max - min))
  }

  getRandomAvatar(index = 0) {
    return 'url(' + this.randomAvatars[index % this.randomAvatars.length] + ')'
  }

  get goDetailExposure() {
    const { id, eventName } = this.value
    return `200023||${JSON.stringify({ activeid: id, name: eventName, tabname: this.tab.tabName })}`
  }
  goDetail() {
    const { id, eventName } = this.value
    this.$newClickTracker({ ...this.pageTrackParams, clickId: '200023', positionParam: { activeid: id, name: eventName, tabname: this.tab.tabName } })
  }

  get linkUrl() {
    return this.kwtarget(toCzj(`https://m.czj100.com/details/event/eventPage?eventId=${this.value.id}`, false))
  }
}
